export default __webpack_public_path__ + "d881ad725e8e0972f589a8ff17e8fcdd.png";